import React from 'react'
import { Col, Row } from 'reactstrap'
import LeftSide from '../Common/LeftSide'
import NewUsersSocial from './NewUsersSocial'
import RightSide from '../Common/RightSide'

export default function TimelineTab() {
    return (
        <Row>
            <LeftSide />
            <Col xl={6} lg={12} md={7} className="box-col-8e xl-60">
                <NewUsersSocial />
            </Col>
            <RightSide />
        </Row>
    )
}
